import { useEffect, useState, useRef } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

import Header from "../../components/Header";
import PosterRow from "../../components/PosterRow/PosterRow";
import HomeSectionRow from "../../components/home/HomeSectionRow";
import NewsCategoryRow from "../../components/home/NewsCategoryRow";
import CricketMatchCard from "../../components/Sports/CricketMatchCard";
import HomeBuzzCard from "../../components/cards/HomeBuzzCard";
import MovieDetailsModal from "../../components/MovieDetailsModal";

import {
  fetchEditorialMovies,
  fetchEditorialWebSeries,
} from "../../api/editorial.firebase";

import { fetchLiveCricketMatches } from "../../api/sports.api";
import { db } from "../../auth/firebase";

import "./Home.css";

function Home() {
  /* ================= STATE ================= */
  const [editorialMovies, setEditorialMovies] = useState([]);
  const [editorialWebSeries, setEditorialWebSeries] = useState([]);
  const [loading, setLoading] = useState(true);

  const [sportsMatches, setSportsMatches] = useState([]);
  const [latestBuzz, setLatestBuzz] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [profileOpen, setProfileOpen] = useState(false);

  const isMobile = window.innerWidth <= 768;
  const navigate = useNavigate();
  
const [selectedMovieId, setSelectedMovieId] = useState(null);

  /* ================= LOAD MOVIES + WEB SERIES ================= */
  useEffect(() => {
    const loadEditorialContent = async () => {
      setLoading(true);

      try {
        const [movies, webSeries] = await Promise.all([
          fetchEditorialMovies(),
          fetchEditorialWebSeries(),
        ]);

        setEditorialMovies(Array.isArray(movies) ? movies : []);
        setEditorialWebSeries(Array.isArray(webSeries) ? webSeries : []);
      } catch (err) {
        console.log("Editorial fetch failed:", err);
      } finally {
        setLoading(false);
      }
    };

    loadEditorialContent();
  }, []);

  /* ================= LOAD SPORTS (AUTO REFRESH) ================= */
  useEffect(() => {
    let mounted = true;

    const loadSports = async () => {
      try {
        const matches = await fetchLiveCricketMatches();
        if (mounted && Array.isArray(matches)) {
          setSportsMatches(matches.slice(0, 10));
        }
      } catch (e) {
        console.warn("Sports refresh skipped");
      }
    };

    loadSports();

    const interval = setInterval(loadSports, 60000); // 60s refresh
    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, []);

  const handleMovieCardClick = (item) => {
    if (!item?.id) return;
    setSelectedMovieId(item.id);
  };

  /* ================= LOAD BUZZ ================= */
  useEffect(() => {
    const loadBuzz = async () => {
      try {
        const q = query(
          collection(db, "latestBuzz"),
          orderBy("publishedAt", "desc")
        );

        const snapshot = await getDocs(q);

        setLatestBuzz(
          snapshot.docs.slice(0, 20).map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
        );
      } catch (err) {
        console.log("Buzz fetch failed:", err);
      }
    };

    loadBuzz();
  }, []);

  /* ================= RENDER ================= */
  return (
    <div className="home-page">
      {/* HEADER */}
      <Header
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onProfile={() => setProfileOpen(true)}
      />



      {/* ⭐ Coming Soon */}
      <PosterRow
  title="Comming Soon in OTT ..."
  fetchData={editorialMovies.slice(0, 10)}
  type="movie"
  large
  autoplay
  viewAllLink="/movies"
  onCardClick={handleMovieCardClick}   // ✅ ADD
/>

<PosterRow
  title="WatchItNow Team Picks – Movies"
  fetchData={editorialMovies.slice(0, 10)}
  type="movie"
  large
  autoplay
  viewAllLink="/movies"
  onCardClick={handleMovieCardClick}   // ✅ ADD
/>

      {/* 📺 Team Picks – Web Series */}
      <PosterRow
        title="WatchItNow Team Picks – Web Series"
        fetchData={editorialWebSeries.slice(0, 10)}
        type="webseries"
        large
        autoplay
        viewAllLink="/webseries"
      />

      {/* 🏏 Cricket Scores */}
      {sportsMatches.length > 0 && <CricketScoresRow matches={sportsMatches} />}

      {/* 🔥 Latest Trailers & Teasers
      {latestBuzz.length > 0 && (
        <HomeSectionRow
          title="🔥 Latest Trailers & Teasers"
          items={isMobile ? latestBuzz.slice(0, 6) : latestBuzz}
          viewAllPath="/buzz"
          renderItem={(item) => <HomeBuzzCard item={item} />}
        />
      )} */}

{selectedMovieId && (
  <MovieDetailsModal
    movieId={selectedMovieId}
    onClose={() => setSelectedMovieId(null)}
  />
)}

      {/* 📰 News
      <NewsCategoryRow /> */}
    </div>

    
  );
}

/* ================= CRICKET ROW ================= */
function CricketScoresRow({ matches }) {
  const rowRef = useRef(null);

  if (!matches.length) return null;

  return (
    <div className="home-section">
      <div className="home-section-header">
        <h2>🏏 Cricket Scores</h2>
        <span className="view-all" onClick={() => alert("Coming Soon!")}>
          View All →
        </span>
      </div>

      <div className="home-row-wrapper">
        <div className="home-row" ref={rowRef}>
          {matches.map((match) => (
            <CricketMatchCard key={match.id} match={match} />
          ))}
        </div>

        <button
          className="scroll-arrow right"
          onClick={() =>
            rowRef.current.scrollBy({ left: 300, behavior: "smooth" })
          }
        >
          ❯
        </button>

        <button
          className="scroll-arrow left"
          onClick={() =>
            rowRef.current.scrollBy({ left: -300, behavior: "smooth" })
          }
        >
          ❮
        </button>
      </div>
    </div>
  );
}

export default Home;
